import { useEffect } from 'react';
import { useGoogleTag } from '../hooks/useGoogleTag';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

export default function SEO({
  title = 'Neural Quest | MMEM Memory Challenge',
  description = 'Test your memory and explore the Mojolagbe Memory Encoding Model (MMEM). An interactive playground for cognitive psychology and neurobiology of learning.',
  keywords = 'memory game, MMEM, cognitive psychology, learning model, neural quest, Jamiu Mojolagbe, information retention',
  image = '/images/logo.webp',
  url = typeof window !== 'undefined'
    ? window.location.origin + window.location.pathname
    : '',
}: SEOProps) {
  useGoogleTag('G-ET7KC0C786');

  useEffect(() => {
    document.title = title;

    const setMetaTag = (name: string, content: string, isProperty = false) => {
      let element = document.querySelector(
        isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`
      );
      if (!element) {
        element = document.createElement('meta');
        if (isProperty) {
          element.setAttribute('property', name);
        } else {
          element.setAttribute('name', name);
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    setMetaTag('description', description);
    setMetaTag('keywords', keywords);
    setMetaTag('author', 'Jamiu Mojolagbe');

    // Open Graph / Facebook
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:image', image, true);
    setMetaTag('og:url', url, true);
    setMetaTag('og:type', 'website', true);

    // Twitter
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
  }, [title, description, keywords, image, url]);

  return null;
}
